import { usePage } from "@inertiajs/react";

/**
 * AD-187: the viewer's Ad Studio role — the one place the frontend reads it.
 *
 *   Admin     internal staff: every ad, Tools, User Management (invite, edit, deactivate)
 *   Publisher its own ads plus every ad of its integrations
 *   User      its own ads only (a colleague's ad by direct link, view-only)
 *   Editor    a Smartico designer: Design Requests and the "Let Us Design It" ads (AD-222)
 *
 * The server decides access; this only picks what the screens show.
 * Null role on pages reachable without logging in (the public changelog).
 */
export const useAdStudioRole = () => {
    const role = usePage().props.auth?.adStudioRole ?? null;

    return {
        role,
        isAdmin: role === 'admin',
        isPublisher: role === 'publisher',
        isUser: role === 'user',
        isEditor: role === 'editor',
    };
};
